export const nuxtMultiCacheUser = 'admin';
export const nuxtMultiCachePassword = 'kofwe@#E-++33';
